var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNiue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe150",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h15v12H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#004a77",
    d: "M7.5 8.3a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe150",
    d: "m7.5 3.77.54 1.4 1.64.04-1.3 1.08.47 1.54L7.5 6.9l-1.35.92.48-1.54L5.32 5.2l1.64-.03zM2.4 5.1l.22.62.67.01-.54.4.2.63-.56-.37-.55.37.2-.63-.54-.4.67-.01zm10.2 0 .23.62.67.01-.54.4.2.63-.55-.37-.56.37.2-.63-.54-.4.67-.01zM7.5 1l.22.62.67.02-.53.4.2.62-.56-.37-.55.37.2-.63-.54-.4h.67zm0 8.34.22.62.67.01-.53.4.2.63-.56-.38-.55.38.2-.63-.54-.4.67-.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiue);
export default __webpack_public_path__ + "static/media/niue.8e95bf0f71a217495e7940ef04ed53b0.svg";
export { ForwardRef as ReactComponent };